const QUESTION_NAMES = {
  FINANCIAL_CONTROL: 'financialControl',
  HANDLE_UNEXPECTED_EXPENSE: 'handleUnexpectedExpense',
  IS_INCOME_FIXED: 'isIncomeFixed',
  JOB_TO_BE_DONE: 'jobToBeDone',
};

const ANSWER_OPTIONS = {
  [QUESTION_NAMES.FINANCIAL_CONTROL]: {
    FULL_CONTROL: 'fullControl',
    SOME_CONTROL: 'someControl',
    NO_CONTROL: 'noControl',
  },
  [QUESTION_NAMES.HANDLE_UNEXPECTED_EXPENSE]: {
    CALM: 'calm',
    STRESSED: 'stressed',
    ANXIOUS: 'anxious',
  },
  [QUESTION_NAMES.IS_INCOME_FIXED]: {
    FIXED: 'fixed',
    SOMEWHAT_FIXED: 'somewhatFixed',
    NOT_FIXED: 'notFixed',
  },
  [QUESTION_NAMES.JOB_TO_BE_DONE]: {
    NO_OVERDRAFT: 'noOverdraft',
    REDUCE_EXPENSES: 'reduceExpenses',
    START_SAVING: 'startSaving',
  },
};

const QUESTIONS = [
  {
    name: QUESTION_NAMES.FINANCIAL_CONTROL,
    text: 'כמה שליטה יש לי במצב הכלכלי שלי…',
    options: [
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.FINANCIAL_CONTROL].FULL_CONTROL,
        label: 'ידוע לי בדיוק מה המצב הכלכלי שלי, אני לגמרי בשליטה',
      },
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.FINANCIAL_CONTROL].SOME_CONTROL,
        label: 'ידוע לי בערך מה המצב הכלכלי שלי',
      },
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.FINANCIAL_CONTROL].NO_CONTROL,
        label: 'לא ידוע לי בכלל מה המצב הכלכלי שלי, אני לא בשליטה',
      },
    ],
  },
  {
    name: QUESTION_NAMES.IS_INCOME_FIXED,
    text: 'ההכנסות החודשיות שלי הן...',
    options: [
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.IS_INCOME_FIXED].FIXED,
        label: 'משכורת חודשית קבועה שאפשר לצפות כבר בתחילת החודש',
      },
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.IS_INCOME_FIXED].NOT_FIXED,
        label: 'אין לי משכורת חודשית קבועה, ההכנסה שלי משתנה בין חודש לחודש',
      },
    ],
  },
  {
    name: QUESTION_NAMES.HANDLE_UNEXPECTED_EXPENSE,
    text: 'החודש צצה הוצאה לא צפויה של ₪8000 שקל, אני...',
    options: [
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.HANDLE_UNEXPECTED_EXPENSE].CALM,
        label: 'אשאר ברגוע, יש לי כסף בצד בדיוק בשביל זה',
      },
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.HANDLE_UNEXPECTED_EXPENSE].STRESSED,
        label: 'קצת בלחץ, אבל אצא מזה בהקדם',
      },
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.HANDLE_UNEXPECTED_EXPENSE].ANXIOUS,
        label: 'ממש בלחץ, יש מצב שאצטרך לקחת הלוואה',
      },
    ],
  },
  {
    name: QUESTION_NAMES.JOB_TO_BE_DONE,
    text: 'הדבר שהכי חשוב לי כרגע הוא...',
    options: [
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.JOB_TO_BE_DONE].NO_OVERDRAFT,
        label: 'לצאת מהמינוס',
      },
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.JOB_TO_BE_DONE].REDUCE_EXPENSES,
        label: 'להצליח לצמצם הוצאות',
      },
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.JOB_TO_BE_DONE].START_SAVING,
        label: 'להתחיל לחסוך לעתיד',
      },
    ],
  },
];

export default {
  QUESTION_NAMES,
  ANSWER_OPTIONS,
  QUESTIONS,
};



// WEBPACK FOOTER //
// ./src/pages/responsive-pages/non-authenticated/wine-and-dine/lead-qualification/consts/questions.js